module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("返回登录\n                    ")])], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('h1', [_vm._v("涵润堂")]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm form1",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "真实姓名：",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.ruleForm.name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "name", $$v)
      },
      expression: "ruleForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话：",
      "prop": "num"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.ruleForm.num),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "num", $$v)
      },
      expression: "ruleForm.num"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系邮箱：",
      "prop": "mail"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.ruleForm.mail),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "mail", $$v)
      },
      expression: "ruleForm.mail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户名：",
      "prop": "userName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.ruleForm.userName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "userName", $$v)
      },
      expression: "ruleForm.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码：",
      "prop": "password"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.ruleForm.password),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "password", $$v)
      },
      expression: "ruleForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "重复密码：",
      "prop": "dbpassword"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.ruleForm.dbpassword),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "dbpassword", $$v)
      },
      expression: "ruleForm.dbpassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "registerBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("注册")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("帮助\n                ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75cb576d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/register.vue
// module id = 1029
// module chunks = 2